// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {SizeTokenValue} from 'common';

import type {HTMLAttributes} from 'react';
import type {CSSObject} from '@emotion/react';

import type {QA} from 'common';

export enum BadgeVariant {
  Red = 'red',
  Accent = 'accent',
  Grey = 'grey',
  Disabled = 'disabled',
}

export type BadgeStyles = {
  /** Размер */
  size: SizeTokenValue;
  /** Вариант */
  variant: BadgeVariant;
  /** Очерченная граница */
  hasStroke?: boolean;
  /** Цвет текста */
  color?: string;
} & Pick<CSSObject, 'backgroundColor' | 'borderColor'>;

export type BadgeProps = Partial<BadgeStyles> & QA & HTMLAttributes<HTMLDivElement>;

export enum BadgeDotSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
}
export type BadgeDotProps = {
  /** Размер */
  size: BadgeDotSize;
} & QA &
  Omit<BadgeProps, 'children' | 'size' | 'color'>;
